import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common'
import { DateComponents } from 'src/app/constants/global-constants';
import { DashboardService } from 'src/app/services/dashboard.service';
import { IBookingRequest, IBookingRequestResponse } from 'src/app/models/dashboard.models';
declare var $: any;

@Component({
  selector: 'app-booking-modal',
  templateUrl: './booking-modal.component.html',
  styleUrls: ['./booking-modal.component.scss']
})
export class BookingModalComponent implements OnInit {

  @Input() bookingReq: IBookingRequest;
  fromDaysDrop :Array<string> ;
  toDaysDrop :Array<string> ;
  daysBackup : Array<string> = DateComponents.days ;
  months = DateComponents.months;
  years = ['2021', '2022', '2023', '2024'];
  today = new Date();
  Days31 = DateComponents.days31;
  Days30 = DateComponents.days30;

  fromDateError: boolean = false;
  toDateError: boolean = false;

  fromDate: Date = new Date();
  toDate: Date = new Date();

  bookingForm = new FormGroup({
    fromDay: new FormControl('', Validators.required),
    fromMonth: new FormControl('', Validators.required),
    fromYear: new FormControl('', Validators.required),
    toDay: new FormControl('', Validators.required),
    toMonth: new FormControl('', Validators.required),
    toYear: new FormControl('', Validators.required)
  });

  @Output() approved = new EventEmitter();
  loading: boolean = false;

  constructor(public datepipe: DatePipe, private dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.today.setHours(0,0,0,0);
    var date = this.datepipe.transform(this.today, 'yyyy-MM-dd');
    if(date)
    {
      let dateSplit = date.split('-');
      this.bookingForm.controls.fromDay.setValue(dateSplit[2]);
      this.bookingForm.controls.fromMonth.setValue(dateSplit[1]);
      this.bookingForm.controls.fromYear.setValue(dateSplit[0]);
      this.bookingForm.controls.toDay.setValue(dateSplit[2]);
      this.bookingForm.controls.toMonth.setValue(dateSplit[1]);
      this.bookingForm.controls.toYear.setValue(dateSplit[0]);
    }
    this.validateDate();
  }

  validateDate(){
    let temp = this.bookingForm.controls.fromYear.value + '-' + this.bookingForm.controls.fromMonth.value
    + '-' + this.bookingForm.controls.fromDay.value;
    let fromDate = new Date(temp);
    
    temp = this.bookingForm.controls.toYear.value + '-' + this.bookingForm.controls.toMonth.value
    + '-' + this.bookingForm.controls.toDay.value;
    let toDate = new Date(temp);
    
    this.fromDateError = fromDate < this.today ? true : false;
    this.toDateError = (toDate < this.today || fromDate > toDate) ? true : false;

    if(this.Days31.includes(this.bookingForm.controls.fromMonth.value))
    {
      this.fromDaysDrop = this.daysBackup;
    }
    else if(this.Days30.includes(this.bookingForm.controls.fromMonth.value)){
      this.fromDaysDrop = this.daysBackup.slice(0,-1);
    }
    else if(new Date(this.bookingForm.controls.fromYear.value+'-02-29').getDate() === 29){
      this.fromDaysDrop = this.daysBackup.slice(0,-2);
    }
    else{
      this.fromDaysDrop = this.daysBackup.slice(0,-3);
    }

    if(this.Days31.includes(this.bookingForm.controls.toMonth.value))
    {
      this.toDaysDrop = this.daysBackup;
    }
    else if(this.Days30.includes(this.bookingForm.controls.toMonth.value)){
      this.toDaysDrop = this.daysBackup.slice(0,-1);
    }
    else if(new Date(this.bookingForm.controls.toYear.value+'-02-29').getDate() === 29){
      this.toDaysDrop = this.daysBackup.slice(0,-2);
    }
    else{
      this.toDaysDrop = this.daysBackup.slice(0,-3);
    }
  }

  approveBooking(){
    this.loading = true;
    let body = {
      requestId: this.bookingReq.requestId,
      mumId: this.bookingReq.mumId,
      startDate: this.bookingForm.controls.fromYear.value + '-' + this.bookingForm.controls.fromMonth.value
                  + '-' + this.bookingForm.controls.fromDay.value,
      endDate: this.bookingForm.controls.toYear.value + '-' + this.bookingForm.controls.toMonth.value
                  + '-' + this.bookingForm.controls.toDay.value
    }

    this.fromDate = new Date(body.startDate);
    this.toDate = new Date(body.endDate);

    this.dashboardService.approveBookingReqandBook(body)
    .subscribe((res: IBookingRequestResponse)=>{
      $('#approve-booking-dates').modal('hide');
      this.approved.emit(res.payload.requestId);
      this.loading = false;
      console.log("Booking Request Approved !",res);
      $('#request-approved-modal').modal('show');
      this.ngOnInit();
    },err=>{
      console.error("Booking Request Approve Failed:", err);
      this.loading = false;
    });
  }
}
